import { useEffect, useState } from "react";
import { Link, Outlet, useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import {
  Spinner,
  Button
} from 'react-bootstrap';

const CardInfo = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [productData, setProductData] = useState();
  const { productCode } = useParams();
  const navigate = useNavigate();
  const [img, setImg] = useState();

  useEffect(() => {
    // loading specific card data
    axios.get(process.env.REACT_APP_HOSTNAME + '/api/client/products/info/' + productCode, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + process.env.REACT_APP_TOKEN
        }
      })
        .then((data) => {
          // console.log(data?.data?.data?.products[0])
          // setProductData(data?.data?.data?.products[0]);
          
          // BIG TODO!!! REMOVE COMMAS FROM MIN/MAX VALUES IN DATABASE
          let dataObj = data?.data?.data?.products[0];
          dataObj.minimum_value = dataObj.minimum_value.replace(',', '');
          dataObj.maximum_value = dataObj.maximum_value.replace(',', '');
          setProductData(dataObj);
          // BIG TODO!!! REMOVE COMMAS FROM MIN/MAX VALUES IN DATABASE
          
          // correct some of GT's errors.
          const imgUrl = data?.data?.data?.products[0].card_image_url;
          const imgUrlArray = imgUrl.split('.');
          if (imgUrlArray[imgUrlArray.length - 1] === 'pngg') {
            setImg(imgUrl.slice(0, imgUrl.length - 1));
          } else {
            setImg(imgUrl);
          }
        })
        .catch((err) => console.log(err))
        .finally(() => setIsLoading(false));
  }, [])

  const goBack = () => {
    navigate(-1);
  };
  
  return (
    <div
      className="mb-3 card-container"
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 1000,
        overflow: 'hidden',
        paddingBottom: 20
      }}
    >
      {isLoading ? (
        <div
          style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      ) : (
        <div style={{height: '100%', paddingTop: '0px',}}>
          <div className="card-info-img-container">
            <img
              src={img || 'https://crm.globetopper.com/brandImages/61086a9b755fc.png'}
              className="img-fluid"
              alt=""
            />
          </div>
          <div style={{
            overflowY: 'scroll',
            height: '100%',
            paddingBottom: '220px'
          }}>
            <div
              className="px-3 pt-3"
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '15px',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  width: '100%'
                }}
              >
                <h5 style={{
                  textAlign: 'left',
                  marginBottom: '0px',
                  fontWeight: 700,
                  fontSize: 20
                }}>
                  <span
                    style={{
                      marginRight: 10,
                      borderRadius: '50%',
                      boxSizing: 'content-box',
                      fontSize: 20
                    }}
                    className={`fi fi-${productData.countries[0]?.toLowerCase()} fis`}></span>
                  {productData.name}
                </h5>
                <span className="item-price-label">
                  {productData.denomination_type === 'open' && 'from ' + +(productData.minimum_value) + ' ' + productData.currency_code}
                  {productData.denomination_type === 'fixed' && +(productData.minimum_value) + ' ' + productData.currency_code}
                </span>
              </div>
            </div>
            
            <div className="px-3">
              <h5>Description:</h5>
              <p>{productData.description}</p>
              {productData.redeem_instructions_html && (
                <>
                  <h5>How to redeem:</h5>
                  <p>{productData.redeem_instructions_html}</p>
                </>
              )}
              {productData.terms_and_conditions_html && (
                <>
                  <h5>Terms and conditions:</h5>
                  <p>{productData.terms_and_conditions_html}</p>
                </>
              )}
            </div>
          </div>

          <div 
            className="button-container px-3"
            style={{
              position: 'absolute',
              bottom: 20,
              left: 0,
              width: '100%',
              textAlign: 'center',
              paddingTop: '10px',
              paddingBottom: '10px',
              bottom: 0,
              backgroundColor: '#253136',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }
          }>
            <div style={{cursor: 'pointer', color: '#ffcd04',}} onClick={goBack}>
              <span className="back-button" style={{fontSize: 16}}>Back</span>
            </div>
            <Link
              to="checkout"
              state={{ productData }}
            >
              <Button variant="gcn-primary" id="button-pay" style={{width: '100%'}}>
                PAY WITH ANY CRYPTOCURRENCY
              </Button>
            </Link>
        </div>
      </div>
      )}

      <Outlet />
    </div>
  );
};

export default CardInfo;
